import { PropsWithChildren, ReactNode } from "react";

import { Stack } from "@mui/material";

import { ClientTabActions } from "../client-tab-actions/ClientTabActions";
import { ClientTabFrame } from "../client-tab-frame/ClientTabFrame";

interface Props extends PropsWithChildren {
  /** Buttons for the tab-actions row above the frame; the row is omitted when not set. */
  tabActions?: ReactNode;
  navigation?: ReactNode;
  /** Slot below the section navigation, e.g. the internal app's client status widget. */
  navigationFooter?: ReactNode;
}

// The standard scaffold of a client-file tab: the optional tab-actions row on top and the
// two-column ClientTabFrame below.
export function ClientTabBase({ tabActions, navigation, navigationFooter, children }: Props) {
  return (
    <Stack flex={"1 1 100%"} gap={2} overflow={"hidden"}>
      {tabActions && <ClientTabActions>{tabActions}</ClientTabActions>}
      <ClientTabFrame navigation={navigation} navigationFooter={navigationFooter}>
        {children}
      </ClientTabFrame>
    </Stack>
  );
}
